















import { Component, Vue, Watch, Prop } from 'vue-property-decorator'
@Component
export default class extends Vue {
  @Prop({
    type: Boolean,
    default: false
  })
  show!: boolean
  @Prop({
    type: String,
    default: false
  })
  showTitle!: string

  curShow = false
  @Prop({
    type: Number,
    default: 10
  })
  zIndex!: number
  @Watch('show')
  showChange(val: boolean) {
    this.curShow = val
  }
  closePop() {
    this.curShow = false
    this.$emit('closePop')
  }
  created() {
    this.curShow = this.show
  }
}
